export const FONT_WEIGHT = {
    font_light: 300,
    font_regular: 400,
    font_weight_600: 600,
    font_bold: 700,
};
export const FONT_STYLE = {
    font_italic: 'italic',
    font_normal: 'normal',
};
export const TEXT_ALIGN = {
    left: 'left',
    center: 'center',
    right: 'right',
};
//# sourceMappingURL=typography.js.map